import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../../../styles/colors.style'
import Browser from '../../../../../services/Browser'
import { breakpoints } from '../../../../../constants'

export const StyledForm = styled.form`
	padding-top: 20px;
	margin-bottom: 4rem;
	border-top: 1px solid ${PRIMARY_COLOR};
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	grid-gap: 4rem 15px;
	flex-wrap: wrap;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		grid-template-columns: repeat(8, 1fr);
		align-items: end;

		& > :nth-child(1),
		& > :nth-child(2),
		& > :nth-child(3),
		& > :nth-child(4),
		& > :nth-child(5),
		& > :nth-child(7),
		& > :nth-child(8),
		& > :nth-child(9),
		& > :nth-child(10) {
			grid-column: auto / span 2;
			width: ${Browser.isIE() ? 'calc((100% / 4) - 15px)' : null};
		}

		& > :nth-child(6) {
			grid-column: auto / span 6;
			width: ${Browser.isIE() ? 'calc(75% - 15px) !important' : null};
		}

		& > :nth-child(11) {
			grid-column: auto / span 8;
			width: 100%;
		}

		/* IE styles */
		& > * {
			margin-bottom: ${Browser.isIE() ? '4rem' : null};
		}

		& > :nth-child(1),
		& > :nth-child(2),
		& > :nth-child(3),
		& > :nth-child(5),
		& > :nth-child(3),
		& > :nth-child(6),
		& > :nth-child(7),
		& > :nth-child(8),
		& > :nth-child(9) {
			margin-right: ${Browser.isIE() ? '15px' : null};
		}
	}
`
